declare global {
  interface Window {
    _hmt: any[]
    aplus_queue?: Array<{ action: string; arguments: unknown[] }>
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    const router = useRouter()

    // Initial check to ensure queues are available
    window._hmt = window._hmt || []
    window.aplus_queue = window.aplus_queue || []

    router.afterEach((to) => {
      // 1. Baidu Analytics SPA tracking
      if (typeof window._hmt !== 'undefined') {
        window._hmt.push(['_trackPageview', to.fullPath])
        console.log('[Analytics] Baidu Tracked:', to.fullPath)
      }

      // 2. Aliyun Aplus (Umeng) SPA tracking
      if (typeof window.aplus_queue !== 'undefined') {
        window.aplus_queue.push({
          action: 'aplus.sendPV',
          arguments: [{ is_auto: false }, { page_path: to.fullPath }]
        })
        console.log('[Analytics] Aplus Tracked:', to.fullPath)
      }
    })
  }
})
